export const loadAsyncCss = (cssUrl: string) => {
  const link = document.createElement('link');
  link.href = cssUrl;
  link.rel = 'stylesheet';
  link.type = 'text/css';

  document.head.appendChild(link);
};
